import { render } from "./DialogActionFix.vue?vue&type=template&id=f5b8d78e"
import script from "./DialogActionFix.vue?vue&type=script&lang=js"
export * from "./DialogActionFix.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__